/**
 * Please keep alphabetical! This allows us to easily double-check which of these actually exist in GrowthBook.
 *
 * If you are deprecating a feature flag. Make sure to delete the corresponding feature flag in GrowthBook after
 * deploying the deprecation.
 */
export enum FEATURE_FLAGS {
  AIR_DNA_MARKET_GRADE = 'air_dna_market_grade',
  AIR_DNA_HISTORICAL_CHARTS = 'air_dna_historical_charts',
  BLOCKED_OFFERINGS = 'blocked_offerings',
  CALENDLY_SIGNUP = 'calendly_signup',
  CASH_ACCOUNT = 'cash_account',
  DEMIO_SIGNUP_PAGE = 'demio_signup_page',
  LANDING_PAGE_SIGNUP = 'landing_page_signup',
  MAINTENANCE_MODE = 'maintenance_mode',
  MAINTENANCE_MODE_LOGGED_IN = 'maintenance_mode_logged_in',
  MARKETING_PAGE_PROPERTIES = 'marketing_page_properties',
  MULTIPLE_ACCOUNTS = 'multiple_accounts',
  NOTIFICATION_BANNER_MESSAGE = 'notification_banner_message',
  OFFERING_REQUEST_SIZE = 'offering_request_size',
  PHONE_CONTACT = 'phone_contact',
  PLAID_MANUAL_BANK_LINK = 'plaid_manual_bank_link',
  PROPERTY_PAGE_EMAIL_SIGNUP = 'property_page_email_signup',
  PROPERTY_TAG_FILTERS = 'property_tag_filters',
  REFERRAL_PROGRAM = 'referral_program',
  ROI_CALCULATOR = 'roi_calculator',
  SHOPPING_CART_TIMER = 'shopping_cart_timer',
  SHOW_ZILLOW_PROPERTY_DETAILS_CHART = 'show_zillow_property_details_chart',
  SIGNUP_POP_UP = 'signup_pop_up',
  SOLD_OUT_POP_UP = 'sold_out_pop_up',
  SUBSCRIBE_FOOTER_TEXT = 'subscribe_footer_text',
  SHOW_PROMOTION_INPUT = 'show_promotion_input',
  SHOW_TOP_BANNER = 'show_top_banner',
  DISABLE_EMAIL_VERIFICATION_REQUIREMENT = 'disable_email_verification_requirement',
  IS_NEW_USER = 'is_new_user',
}
